declare global {
    interface Window {
        language: string,
        translations: Array<string>,
        Alpine: any;
        Pinia: any;
    }
}

// import css
import '~/css/runmate.css'

// import icons
import '~/js/assets/icons.js'

// alpine
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import heroVideo from '~/js/alpine/hero-video'
window.Alpine = Alpine
Alpine.plugin(focus)

const navigation = () => ({
    showMenu: false,
})
const tabs = () => ({
    activeTab: '1',
    onSetActiveTab(tab:string) {
        this.activeTab = tab
    }
})
Alpine.data('navigation', navigation)
Alpine.data('tabs', tabs)
Alpine.data('heroVideo', heroVideo)
Alpine.start()

// animation
if (document.querySelector('[class*="animate-"]')) {
    import('~/js/utils/animations-runmate').then(({ animateComponents }) => animateComponents())
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}